import "./App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import SiteGate from "./components/SiteGate";
import PublicLayout from "./components/PublicLayout";
import ProtectedRoute from "./components/ProtectedRoute";
import Home from "./pages/Home";
import WhoWeAre from "./pages/WhoWeAre";
import Directors from "./pages/Directors";
import Connect from "./pages/Connect";
import Projects from "./pages/Projects";
import AdminDashboard from "./pages/AdminDashboard";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <SiteGate>
            <Routes>
              <Route element={<PublicLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/who-we-are" element={<WhoWeAre />} />
                <Route path="/directors" element={<Directors />} />
                <Route path="/connect" element={<Connect />} />
              </Route>

              <Route path="/projects" element={<Projects />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute requireAdmin redirectTo="/">
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </SiteGate>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
